import styled from 'styled-components';

export const StyledStripePayment = styled.div`
  width: 100%;
`;

export const StyledStripeForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;

  button {
    margin-top: 10px;
  }
`;
